import { SearchInput } from '../shared';
import { SortOrder, ModuleSortType } from '../enums';

export class GetModulesInput extends SearchInput<ModuleSortType> {
    constructor() {
        super(ModuleSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}